export type BreakpointType = 'laptop' | 'tablet'

export function footerBreakpoint(locale: string): BreakpointType {
  return locale === 'fr' ? 'laptop' : 'tablet'
}
